/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamAggregateTimeSlotStateResponse } from './oralExamAggregateTimeSlotStateResponse';

export type GenericApiResponseOralExamAggregateTimeSlotStateResponseData =
  OralExamAggregateTimeSlotStateResponse | null;
